window.addEventListener('DOMContentLoaded', () => {
  const focusFly = document.createElement('jb-focus-fly');
  document.body.appendChild(focusFly);
});
